import { PdsWidget } from './pds-widget';
import { pdsI18n } from './pds-i18n';

export class PdsCircularProgress extends PdsWidget {
    is = 'pds-circular-progress';

    dataValue: number;
    dataMax: number;
    dataPercent: number;
    dataColor: string; //valid values are empty (pds-default-color), red (pds-red), orange (pds-orange), blue (pds-blue), green (pds-green)
    dataSize: string; //valid values are empty (pds-default-size), small (pds-small), medium (pds-medium)

    properties = {
        dataValue: {
            type: Number,
            value: 0
        },
        dataMax: {
            type: Number,
            value: 0
        },
        dataPercent: {
            type: Number,
            value: null
        },
        dataColor: {
            type: String,
            value: 'pds-default-color'
        },
        dataSize: {
            type: String,
            value: 'pds-default-size'
        },
        bgcolor: {
            type: String,
            value: 'white'
        }
    };

    getColorClass(): String {
        if (this.dataColor == null) {
          return 'pds-default-color';
        }

        //make sure what was passed is valid and not silly
        if (!this.dataColor.startsWith('pds-')) {
            this.dataColor = 'pds-' + this.dataColor;
        }
        if (this.dataColor === 'pds-default-color' || this.dataColor === 'pds-green' ||
            this.dataColor === 'pds-orange' || this.dataColor === 'pds-red' || this.dataColor === 'pds-blue') {
            //valid - return it
            return this.dataColor;
        } else {
            //something silly - or maybe we want to extend this to accept (after verifying) arbitrary hex values
            return 'pds-default-color';
        }

    }

    getSizeClass(): String {
        if (this.dataSize == null) {
          return 'pds-default-size';
        }

        if (!this.dataSize.startsWith('pds-')) {
            this.dataSize = 'pds-' + this.dataSize;
        }
        if (this.dataSize === 'pds-default-size' || this.dataSize === 'pds-small' || this.dataSize === 'pds-medium') {
            //valid - return it
            return this.dataSize;
        }
        //else not valid
        return 'pds-default-size';
    }

    //helper function to determine if the value should be treated like a zero - protects against user-error if the
    //values passed are empty or invalid (as well as just plain zero)
    isLogicalZero(testVal): boolean {
        return (isNaN(testVal) || testVal == null || testVal <= 0);
    }

    //function to determine if the graphic is in a 'completed' state
    isComplete(): boolean {
        //if a percent was passed directly, use that
        if (this.dataPercent) {
            return (this.dataPercent >= 100);
        }
        //otherwise attempt to calculate it from the value/max
        if (this.isLogicalZero(this.dataMax) || this.isLogicalZero(this.dataValue)) {
            return false;
        }
        if (this.dataValue >= this.dataMax) {
            return true;
        }
        //val = this.value / this.max * 100;
        return false;
    }

    //function to return a text message for the graphic
    getCompleteMessage(): String {
        //using Percent, give a percenty message
        if (this.dataPercent != null) {
            return pdsI18n.getText('pds|circular progress|xx% Complete', {percent: this.dataPercent});
        }
        //otherwise attempt to calculate it from the value/max
        let value = 0;
        let max = 0;
        if (this.dataValue != null && this.dataValue > 0) {
            value = this.dataValue;
        }//else let value stay at default zero
        if (this.dataMax != null && this.dataMax > 0) {
            max = this.dataMax;
        }
        return pdsI18n.getText('pds|circular progress|xx of xx', {value: value, max: max});
    }

    //function for calculating the precentage for the graph that will not do anything silly like divide by zero
    getSafePercent(): number {
        //if a percent was passed directly, use that
        if (this.dataPercent) {
            //autocorrect
            if (this.dataPercent < 0) {
                this.dataPercent = 0;
            }
            if (this.dataPercent > 100) {
                this.dataPercent = 100;
            }
            //make sure the returned value is a whole number
            return Math.round(this.dataPercent);
        }
        //otherwise attempt to calculate it from the value/max
        if (this.isLogicalZero(this.dataMax) || this.isLogicalZero(this.dataValue)) {
            return 0;
        }
        if (this.dataValue >= this.dataMax) {
            return 100;
        }
        //make sure the returned value is a whole number
        return Math.round(this.dataValue / this.dataMax * 100);
    }

}
